var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleHung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "double-hung",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.1,89.8h15.5c1.2,0,2.1-0.9,2.1-2.1l0,0c0.1-1.1-0.8-2-1.9-2.1c-0.1,0-0.2,0-0.2,0H92.1c-1.2,0-2.1,0.9-2.1,2.1 C90,88.9,91,89.8,92.1,89.8z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.1,120h15.5c1.2,0,2.1-0.9,2.1-2.1l0,0c0.1-1.1-0.8-2-1.9-2.1c-0.1,0-0.2,0-0.2,0H92.1c-1.2,0-2.1,0.9-2.1,2.1 C90,119.1,91,120,92.1,120z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M167.8,14.6H31.9v170.7h136.1V14.6H167.8z M163.2,104.6H36.5v-5h126.7L163.2,104.6z M163.2,19.5V95H36.5V19.5H163.2z  M36.5,180.8v-71.3h126.7v71.3H36.5z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.4,145.6l-8.5-14.8l-8.5,14.8H95v10.9h9.8v-10.9H108.4z M103.7,155.3h-7.6v-9.7v-1.1H95h-1.6l6.6-11.4l6.6,11.4h-1.7 h-1.1v1.1V155.3z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.4,57.5l8.5,14.8l8.5-14.8h-3.6V46.6H95v10.9H91.4z M96.1,47.7h7.6v9.7v1.1h1.1h1.6L99.9,70l-6.6-11.4H95h1.1v-1.1 V47.7z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168.4,199H31.6c-6.2,0-11.2-5-11.2-11.2V12.2C20.4,6,25.4,1,31.6,1h136.9c6.2,0,11.2,5,11.2,11.2v175.6 C179.6,194,174.6,199,168.4,199z M31.6,5.8c-3.5,0-6.4,2.9-6.4,6.4v175.6c0,3.5,2.9,6.4,6.4,6.4h136.9c3.5,0,6.4-2.9,6.4-6.4V12.2 c0-3.5-2.9-6.4-6.4-6.4H31.6z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleHung);
export default __webpack_public_path__ + "static/media/double-hung.909fe036de606eb792572046d2041954.svg";
export { ForwardRef as ReactComponent };